import ACCOUNT_DETAILS_FIELDS from '../../../../../common/constants/accountPersonalDetailsFields';

const PREDICTIONS_ACCOUNT_DETAILS_FIELDS = ACCOUNT_DETAILS_FIELDS.filter(field => !['jobTitle', 'salaryRange'].includes(field.name));

export default PREDICTIONS_ACCOUNT_DETAILS_FIELDS;
